import * as React from 'react';
//import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import axios from 'axios'

const baseApiUri = process.env.REACT_APP_API_URL;

export default function PortalEditElement(props) {

    console.log('PROPS EDIT',props);

        async function editIndicator(){

        console.log('ADD PROPS',props);
        console.log('VALUE',value);
        console.log('LINK',link);
        console.log('URL', url);
        console.log('EDITING: ',props.currentElement);
        console.log('EDITING ID: ', props.currentElementId);

            console.log('edit indicator');
            if(value !== ''){
                try{
                    let payload = {
                        eltid: props.currentElementId,
                        eltval:value,
                        elturl:url,
                        eltlink: link,
                        elttype: props.currentEltType
                    }
                    console.log('PAYLOAD', payload);
                    //return true;
                    let endpoint = `${baseApiUri}/portals/editindicator`;
                    let elt = await axios.post(endpoint, payload,{withCredentials: true} );
                    console.log('UPDATED INDICATOR',elt);

                } catch(e){}
            }
            
            
        
        
        props.reload();
        props.editClose();


    }

    async function editElement(){

        console.log('ADD PROPS',props);
        console.log('VALUE',value);
        console.log('EDITING: ',props.currentElement);
        console.log('EDITING ID: ', props.currentElementId);

            console.log('edit element');
            if(value !== ''){
                try{
                    let payload = {
                        eltid: props.currentElementId,
                        eltval: value,
                        elttype: props.currentEltType
                    }
                    console.log('PAYLOAD', payload);
                    let endpoint = `${baseApiUri}/portals/editelement`;
                    let elt = await axios.post(endpoint, payload,{withCredentials: true} );
                    console.log(elt);

                } catch(e){}
            }
            
            
        
        
        props.reload();
        props.editClose();


    }

    let initVal = '';
    let initUrl = '';
    let initLink = '';
    try{
        initVal = props.currentElement[0].name;
        initUrl = props.currentElement[0].chart_url;
        initLink = props.currentElement[0].link;
    } catch(e){
        initVal = props.currentElement[0].title;
    }

    const [value, setValue] = React.useState(initVal);
    const [url, setUrl] = React.useState(initUrl);
    const [link, setLink] = React.useState(initLink);
    
  
 //console.log('TAB PROPS', props);
  //let elt = props.currentElement[0];
  //console.log('ELT', elt);

  const handleTextFieldChange = (event) => {
    setValue(event.target.value);
  };

  const handleUrlTextFieldChange = (event) => {
    console.log(url);
    setUrl(event.target.value);
  };

  const handleLinkTextFieldChange = (event) => {
    console.log(link);
    setLink(event.target.value);
  };


  return (
    <Box sx={{ width: '100%' }}>
     <div style={{margin:'20px'}}  >
        
        { props.currentEltType === 'p' &&
        <TextField value={value}   defaultValue={props.currentElement[0].name}  style={{marginRight:'5px'}} onChange={handleTextFieldChange}  id="id-topic" label="edit topic" variant="outlined" />
         }
         { props.currentEltType === 't' &&
         <>
         <TextField value={value} defaultValue={props.currentElement[0].name} style={{marginRight:'5px',marginTop:'5px'}} onChange={handleTextFieldChange}  id="id-topic" label="edit topic" variant="outlined" />
        </>
         }
         { props.currentEltType === 'c' &&
         <>
         <TextField value={value}  defaultValue={props.currentElement[0].name}  style={{marginRight:'5px'}} onChange={handleTextFieldChange}  id="id-category" label="edit category" variant="outlined" />
         </>
          
          }
           { props.currentEltType === 's' &&
         <>
         <TextField value={value}  defaultValue={props.currentElement[0].name}  style={{marginRight:'5px'}} onChange={handleTextFieldChange}  id="id-subcategory" label="edit subcategory" variant="outlined" />
         </>
          
          }
           { props.currentEltType === 'i' &&
         <>
          <TextField  defaultValue={props.currentElement[0].title} style={{marginRight:'5px',marginTop:'5px'}} onChange={handleTextFieldChange}  id="id-indicator-title" label="indicator title" variant="outlined" />
          <TextField  defaultValue={props.currentElement[0].chart_url} style={{marginRight:'5px',marginTop:'5px'}} onChange={handleUrlTextFieldChange}  id="id-indicator-url" label="indicator url" variant="outlined" />
          <TextField  defaultValue={props.currentElement[0].link} style={{marginRight:'5px',marginTop:'5px'}} onChange={handleLinkTextFieldChange}  id="id-indicator-link" label="indicator link" variant="outlined" />
         </>
          
          }
          


         <Button style={{marginTop:'20px'}}variant="contained" onClick={props.currentEltType === 'i' ? editIndicator : editElement}>Edit</Button>




         
         
      </div>
    </Box>
  );
}